import { useEffect, useState } from 'react';
import { canWriteEmpresaData } from '../../auth/session';
import { createItem, deleteItem, fetchList, updateItem } from './api';
import CrudModal from '../../components/layout/CrudModal';

const EMPTY = {
  tipo: 'fornecedor',
  nome: '',
  documento: '',
  telefone: '',
  email: '',
  ativo: true,
};

const ConstrutorPessoasPage = () => {
  const canWrite = canWriteEmpresaData();
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(EMPTY);
  const [q, setQ] = useState('');
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [editingId, setEditingId] = useState('');
  const [showFormModal, setShowFormModal] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const data = await fetchList('/api/construtor/pessoas', { q, page, pageSize: 10 });
      setItems(Array.isArray(data?.items) ? data.items : []);
      setTotal(Number(data?.total || 0));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [page]);

  const onSubmit = async (e) => {
    e.preventDefault();
    const payload = { ...form };
    if (editingId) {
      await updateItem('/api/construtor/pessoas', editingId, payload);
    } else {
      await createItem('/api/construtor/pessoas', payload);
    }
    setEditingId('');
    setForm(EMPTY);
    setShowFormModal(false);
    await load();
  };

  const onDelete = async (id) => {
    if (!window.confirm('Excluir pessoa?')) return;
    await deleteItem('/api/construtor/pessoas', id);
    await load();
  };

  const onEdit = (item) => {
    setEditingId(item.id);
    setForm({
      tipo: item.tipo || 'fornecedor',
      nome: item.nome || '',
      documento: item.documento || '',
      telefone: item.telefone || '',
      email: item.email || '',
      ativo: item.ativo !== false,
    });
    setShowFormModal(true);
  };

  const totalPages = Math.max(1, Math.ceil(total / 10));

  return (
    <div className="animate-fade-in space-y-6">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Pessoas</h1>
        {canWrite && (
          <button
            type="button"
            className="btn-primary"
            onClick={() => {
              setEditingId('');
              setForm(EMPTY);
              setShowFormModal(true);
            }}
          >
            Incluir Pessoa
          </button>
        )}
      </div>

      {canWrite && (
        <CrudModal
          open={showFormModal}
          title={editingId ? 'Editar Pessoa' : 'Nova Pessoa'}
          onClose={() => {
            setShowFormModal(false);
            setEditingId('');
            setForm(EMPTY);
          }}
          maxWidthClass="max-w-4xl"
        >
          <form onSubmit={onSubmit} className="space-y-5">
            <div className="rounded-xl border border-gray-200 bg-gray-50/50 p-4">
              <p className="text-sm font-semibold text-gray-800">Cadastro de Pessoa</p>
              <p className="text-xs text-gray-500 mt-1">Use para fornecedores, clientes ou ambos.</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label className="form-label">Tipo</label>
                <select className="form-select" value={form.tipo} onChange={(e) => setForm({ ...form, tipo: e.target.value })}>
                  <option value="fornecedor">Fornecedor</option>
                  <option value="cliente">Cliente</option>
                  <option value="ambos">Ambos</option>
                </select>
              </div>
              <div>
                <label className="form-label">Nome</label>
                <input className="form-input" placeholder="Nome completo ou razao social" value={form.nome} onChange={(e) => setForm({ ...form, nome: e.target.value })} />
              </div>
              <div>
                <label className="form-label">Documento (CPF/CNPJ)</label>
                <input className="form-input" placeholder="Somente numeros ou formatado" value={form.documento} onChange={(e) => setForm({ ...form, documento: e.target.value })} />
              </div>
              <div>
                <label className="form-label">Telefone</label>
                <input className="form-input" placeholder="(00) 00000-0000" value={form.telefone} onChange={(e) => setForm({ ...form, telefone: e.target.value })} />
              </div>
              <div>
                <label className="form-label">Email</label>
                <input className="form-input" placeholder="email@dominio.com" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
              </div>
              <div className="flex items-end pb-2">
                <label className="inline-flex items-center gap-2 text-sm text-gray-700">
                  <input type="checkbox" checked={form.ativo} onChange={(e) => setForm({ ...form, ativo: e.target.checked })} />
                  Ativo
                </label>
              </div>
            </div>

            <div className="flex items-center justify-end gap-2 border-t pt-4">
              <button
                className="btn-secondary"
                type="button"
                onClick={() => {
                  setShowFormModal(false);
                  setEditingId('');
                  setForm(EMPTY);
                }}
              >
                Cancelar
              </button>
              <button className="btn-primary" type="submit">{editingId ? 'Atualizar Pessoa' : 'Salvar Pessoa'}</button>
            </div>
          </form>
        </CrudModal>
      )}

      <div className="card">
        <div className="card-header flex items-center gap-3">
          <input className="form-input max-w-sm" placeholder="Buscar nome/documento/email..." value={q} onChange={(e) => setQ(e.target.value)} />
          <button className="btn-secondary" onClick={() => { setPage(1); load(); }}>Buscar</button>
        </div>
        <div className="card-body p-0">
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>Tipo</th>
                  <th>Nome</th>
                  <th>Documento</th>
                  <th>Contato</th>
                  <th>Status</th>
                  <th>Acoes</th>
                </tr>
              </thead>
              <tbody>
                {items.map((it) => (
                  <tr key={it.id}>
                    <td>{it.tipo}</td>
                    <td>{it.nome}</td>
                    <td>{it.documento || '-'}</td>
                    <td>{it.email || it.telefone || '-'}</td>
                    <td>{it.ativo ? 'Ativo' : 'Inativo'}</td>
                    <td>
                      {canWrite && <button className="btn-secondary mr-2" onClick={() => onEdit(it)}>Editar</button>}
                      {canWrite && <button className="btn-danger" onClick={() => onDelete(it.id)}>Excluir</button>}
                    </td>
                  </tr>
                ))}
                {!loading && items.length === 0 && <tr><td colSpan={6} className="text-center text-gray-500 py-6">Sem dados</td></tr>}
                {loading && <tr><td colSpan={6} className="text-center text-gray-500 py-6">Carregando...</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
        <div className="card-body border-t flex items-center justify-between">
          <span className="text-sm text-gray-600">Pagina {page} de {totalPages} ({total} registros)</span>
          <div className="flex gap-2">
            <button className="btn-secondary" disabled={page <= 1} onClick={() => setPage((p) => Math.max(1, p - 1))}>Anterior</button>
            <button className="btn-secondary" disabled={page >= totalPages} onClick={() => setPage((p) => Math.min(totalPages, p + 1))}>Proxima</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConstrutorPessoasPage;
